import { render } from "./Leaderboard.vue?vue&type=template&id=d39da24a&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=d39da24a&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39da24a"]])

export default __exports__